import {TextItemPanels} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-text-options/poster-editing-text-options.types';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';
import {useGetKeyFromListOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromListOfActiveItem';
import {useGetKeyFromFillOfBackgroundOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfBackgroundOfActiveItem';
import {useGetKeyFromShadowOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromShadowOfActiveItem';
import {useEffect} from 'react';
import {LIST_TYPES} from '@PosterWhiteboard/items/text-item/text-list';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import {ShadowOrGlowType} from '@postermywall/fabricjs-2';

export function useIsOpenedTextPanelValid(currentlyOpenedPanel: TextItemPanels, setCurrentlyOpenedPanel: (newVal: TextItemPanels) => void): void {
  const stroke = useGetKeyFromTextStylesActiveItem('stroke');
  const listType = useGetKeyFromListOfActiveItem('type');
  const bgFillType = useGetKeyFromFillOfBackgroundOfActiveItem('fillType');
  const shadowOrGlowType = useGetKeyFromShadowOfActiveItem('shadowOrGlowType');

  const revertPanelToDefault = (): void => {
    setCurrentlyOpenedPanel(TextItemPanels.NONE);
  };

  useEffect((): void => {
    if (!stroke && currentlyOpenedPanel === TextItemPanels.OUTLINE) {
      revertPanelToDefault();
    }
  }, [stroke]);

  useEffect((): void => {
    if (listType === LIST_TYPES.NONE && currentlyOpenedPanel === TextItemPanels.LIST_COLOR) {
      revertPanelToDefault();
    }
  }, [listType]);

  useEffect((): void => {
    if (bgFillType === FillTypes.NONE && currentlyOpenedPanel === TextItemPanels.BACKGROUND_COLOR) {
      revertPanelToDefault();
    }
  }, [bgFillType]);

  useEffect((): void => {
    if (shadowOrGlowType !== ShadowOrGlowType.CUSTOM_SHADOW && currentlyOpenedPanel === TextItemPanels.CUSTOM_SHADOW) {
      revertPanelToDefault();
    }
  }, [shadowOrGlowType]);

  return;
}
